import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardDescription, CardHeader, CardTitle, Stack } from '@shared/ui';
import { WeeklyReportCard } from '@widgets/weekly-report-card';

export function WeeklyReportCardShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          {t('uiLibrary.dataDisplay.weeklyReportCard.title', 'Weekly report card')}
        </CardTitle>
        <CardDescription>
          {t(
            'uiLibrary.dataDisplay.weeklyReportCard.description',
            'Reusable weekly report card layout with dynamic sections.'
          )}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Stack gap="md">
          <WeeklyReportCard
            title="Jan 6, 2026 – Jan 12, 2026"
            subtitle={t('uiLibrary.dataDisplay.weeklyReportCard.subtitle', 'Sample weekly summary')}
            locale="en"
            kpis={[
              {
                label: t('analytics.weekly.kpi.registrations', 'Registrations'),
                value: 312,
                subtext: t('analytics.weekly.labels.weeklyTotal', 'Weekly total'),
                percentChange: 4.01,
                comparisonLabel: t('analytics.weekly.labels.vsAvg', 'vs avg'),
              },
              {
                label: t('analytics.weekly.kpi.trainingPrograms', 'Training programs sold'),
                value: 0,
                subtext: t('analytics.weekly.labels.weeklyTotal', 'Weekly total'),
                percentChange: -100,
                comparisonLabel: t('analytics.weekly.labels.vsAvg', 'vs avg'),
              },
              {
                label: t('analytics.weekly.kpi.activeInstructors', 'Active instructors'),
                value: 902,
                subtext: t('analytics.weekly.labels.weeklyTotal', 'Weekly total'),
                percentChange: 7.62,
                comparisonLabel: t('analytics.weekly.labels.vsAvg', 'vs avg'),
              },
            ]}
            sections={[
              {
                title: t('analytics.weekly.sections.registrations', 'User Registrations'),
                items: [
                  {
                    label: t('analytics.weekly.labels.total', 'Total'),
                    value: '312',
                    suffix: {
                      value: 4.01,
                      tone: 'change',
                      label: t('analytics.weekly.labels.vsAvg', 'vs avg'),
                    },
                  },
                  {
                    label: t('analytics.weekly.labels.paid', 'Paid'),
                    value: '284',
                    suffix: {
                      value: 91.03,
                      tone: 'share',
                      label: t('analytics.weekly.labels.ofTotal', 'of total'),
                    },
                  },
                ],
              },
              {
                title: t('analytics.weekly.sections.emActivity', 'EM Learning Activity'),
                subsections: [
                  {
                    title: t('analytics.weekly.sections.emModules', 'EM Modules'),
                    items: [
                      {
                        label: t('analytics.weekly.labels.modulesStarted', 'Modules started'),
                        value: '178',
                        suffix: {
                          value: -15.95,
                          tone: 'change',
                          label: t('analytics.weekly.labels.vsAvg', 'vs avg'),
                        },
                      },
                      {
                        label: t('analytics.weekly.labels.modulesCompleted', 'Modules completed'),
                        value: '124',
                        suffix: {
                          value: 69.66,
                          tone: 'share',
                          label: t('analytics.weekly.labels.ofStarted', 'of started'),
                        },
                      },
                    ],
                  },
                ],
              },
            ]}
            insights={t(
              'uiLibrary.dataDisplay.weeklyReportCard.insights',
              'Registrations increased slightly, but training programs remain flat.'
            )}
            insightsLabel={t('analytics.weekly.sections.insights', 'Insights')}
            formatters={{
              signedPercent: (value) =>
                `${value > 0 ? '+' : value < 0 ? '-' : ''}${Math.abs(value).toFixed(2)}%`,
              percent: (value) => `${value.toFixed(2)}%`,
            }}
          />
        </Stack>
      </CardContent>
    </Card>
  );
}
